import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, WritableSignal, inject, signal } from '@angular/core';
import { SettingDataOutputModel } from '@travel/shared';
import { DataConfig } from './configs';
import { StateService } from './state.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private _httpClient = inject(HttpClient);
  // userProfile: UserProfileOutputModel;
  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');
  constructor(private _stateService: StateService, @Inject('environment') private environment: any) {
    // this.userProfile = _storageService.get('USER_PROFILE');
  }

  getWhiteLabel(_domainName: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient
        .post(`${this.environment.baseURL}/unAuthorized/get/whiteLabel`, {
          agencyId: null,
          domainName: _domainName,
          // languageId: 1
        })
        .subscribe({
          next: (res: any) => resolve(res.result),
          error: (err: any) => reject(err),
        });
    });
  }

  captchaGenerate(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${this.environment.captchaURL}/unsecured/captcha/generate`).subscribe({
        next: (res: any) => resolve(res.result),
        error: (err: any) => reject(err),
      });
    });
  }

  // سرچ با صفحه ساز
  hotelSearchPageBuilder(body: any): Promise<any> {
    const hotelSearch = new Promise((resolve, reject) => {
      const url =  '/unAuthorized/searchHotelWLs';
      this._httpClient.post(`${this.environment.baseURL}${url}`, body).subscribe({
        next: (res: any) => resolve(res.result),
        error: (err: any) => reject(err),
      });
    });
    return hotelSearch;
  }

  // سرچ با صفحه ساز
  getWebPage(body: any): Observable<any> {
      return this._httpClient.post(`${this.environment.baseURL}/unAuthorized/get/webPage`, body)
  }

  // الستیک سرچ هتل
  hotelElasticSearch(params: any): Promise<any> {
    
    this.settingData = DataConfig.get('globalSetting');
    return new Promise((resolve, reject) => {
      this._httpClient
        .post(`${this.environment.baseURL}/unAuthorized/getAllHotelCityProvinceCita`, {
          languageId: 1,
          txt: params?.filter?.value === undefined || params?.filter?.value === null ? '' : params?.filter?.value,
          terminalCode: this.settingData.terminalCode,
          take: params.take,
          skip: params.skip,
        })
        .subscribe({
          next: (res: any) => resolve({ items: res.result.cityProvinceResponses, total: res.result.total }),
          error: (err: any) => reject(err),
        });
    });
  }

  // الستیک سرچ هتل
  hotelElasticSearchWl(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = '/unAuthorized/ml/search';
      this._httpClient
        .post(`${this.environment.baseURL}${url}`, {
          take: params.take,
          skip: params.skip,
          sort: null,
          group: null,
          aggregate: null,
          data: {
            languageID: 1,
            whiteLabelId: DataConfig.get('globalSetting').whiteLabelId,
            agencyId: DataConfig.get('globalSetting').agencyId,
          },
          filter: {
            filters: [
              {
                filters: [
                  {
                    filters: [],
                    field: 'cityName',
                    disable: false,
                    joinType: 'INNER',
                    logic: null,
                    value: params?.filter?.value === undefined || params?.filter?.value === null ? '' : params?.filter?.value,
                    operator: 'contains',
                    ignoreCase: true,
                    truncateDate: true,
                  },
                  {
                    filters: [],
                    field: 'hotelName',
                    disable: false,
                    joinType: 'INNER',
                    logic: null,
                    value: params?.filter?.value === undefined || params?.filter?.value === null ? '' : params?.filter?.value,
                    operator: 'contains',
                    ignoreCase: true,
                    truncateDate: true,
                  },
                  {
                    filters: [],
                    field: 'provinceName',
                    disable: false,
                    joinType: 'INNER',
                    logic: null,
                    value: params?.filter?.value === undefined || params?.filter?.value === null ? '' : params?.filter?.value,
                    operator: 'contains',
                    ignoreCase: true,
                    truncateDate: true,
                  },
                ],
                logic: 'or',
              },
            ],
            logic: 'and',
          },
          providerQualifier: null,
        })
        .subscribe({
          next: (res: any) => resolve({ items: res.result.data, total: res.result.total }),
          error: (err: any) => reject(err),
        });
    });
  }

  // دریافت اطلاعات پروفایل کاربر
  getUserProfile(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${this.environment.baseURL}/userProfile/get/${id}`).subscribe({
        next: (res: any) => resolve(res.result),
        error: (err: any) => reject(err),
      });
    });
  }

  // دریافت شناسه کیف پول
  getWalletInfo(_walletInfo: any): Promise<[]> {
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${this.environment.baseURL}/wallet/getWalletInfo`, _walletInfo).subscribe({
        next: (res: any) => resolve(res.result),
        error: (err: any) => reject(err),
      });
    });
  }

  // دریافت موجودی کیف پول
  getWalletBalance(_walletId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${this.environment.baseURL}/wallet/getWalletBalance/${_walletId}`).subscribe({
        next: (res: any) => resolve(res.result),
        error: (err: any) => reject(err),
      });
    });
  }

  // دریافت توکن برای باز کردن صفحه پرداخت
  samanEpay(_body: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${this.environment.baseURL}/shaparak/wallet/token`, _body).subscribe({
        next: (res: any) => resolve(res.result),
        error: (err: any) => reject(err),
      });
    });
  }

  getFAQList(hotelFAQObj: any) {
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${this.environment.baseURL}/faq/getFAQList`, hotelFAQObj).subscribe({
        next: (res: any) => resolve(res.result.data),
        error: (err: any) => reject(err),
      });
    });
  }

  printReceiveReceipt(body: any) {
    return new Promise((resolve, reject) => {
      this._httpClient
        .post(
          `${this.environment.baseURL}/reportReserve/reportVoucher`,
          {
            path: '/vocherHotel.pdf',
            reportName: 'reportVoucher',
            reportType: 'pdf',
            params: {
              agencyID: Number(body.agencyId),
              reserveNumber: body.reserveNumber,
              hotelID: Number(body.hotelId),
              reserveId: Number(body.reserveId),
            },
          },
          {
            responseType: 'blob',
            observe: 'response',
          }
        )
        .subscribe({
          next: (res: any) => resolve(res),
          error: (err: any) => reject(err),
        });
    });
  }

  //لیستی از لندینگ پیج ها
  activeLandingPage(): Promise<any> {
    this.settingData = DataConfig.get('globalSetting');
    return new Promise((resolve, reject) => {
      this._httpClient
        .post(`${this.environment.unsecuredURL}/activeLandingPage`, {
          sort: null,
          filter: {},
          data: {
            terminalCode: this.settingData.terminalCode,
            languageId: 1,
          },
          providerQualifier: 'activeLandingPageGridProvider',
          aggregate: null,
          group: null,
          skip: 0,
          take: 100,
        })
        .subscribe({
          next: (res: any) => resolve(res.result.data),
          error: (err: any) => reject(err),
        });
    });
  }

  // private scrollEvent = new Subject<{ scrollTop: number; clientHeight: number }>();
  // scrollEvent$ = this.scrollEvent.asObservable();
  // emitScrollEvent(scrollData: { scrollTop: number; clientHeight: number }) {
  //   this.scrollEvent.next(scrollData);
  // }

  scrollEventPage: WritableSignal<{ scrollTop: number; clientHeight: number ;scrollHeight:number}> =signal({scrollTop: 0, clientHeight: 0,scrollHeight:0})


}
